// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "th.column-test, td.column-test {\n  min-width: 30%;\n  width: 30%;\n}\nth.column-campaign, td.column-campaign {\n  min-width: 30%;\n  width: 30%;\n}\n.test-select:invalid, .test-select [disabled] {\n  color: #999;\n  background-color: #EEE;\n}\n.test-select option {\n  color: black;\n  background-color: transparent;\n}\n.test-select option[already-selected] {\n  background-color: var(--lingusta-green-subtle);\n  color: #eee;\n}", ""]);
// Exports
module.exports = exports;
